import { useQuery } from '@tanstack/react-query'

import { fetchCampaignDetail } from '@/lib/venue/campaignApi'

export function campaignDetailQueryKey(venueId: string, campaignId: number) {
  return ['venue', venueId, 'campaign-detail', campaignId] as const
}

export function useCampaignDetail(venueId: string, campaignId: number) {
  return useQuery({
    queryKey: campaignDetailQueryKey(venueId, campaignId),
    queryFn: () => fetchCampaignDetail(venueId, campaignId),
    enabled: Number.isFinite(campaignId),
  })
}
